import React, { useState } from "react";
import html2canvas from "html2canvas";
import styles from "./DownloadChartButton.module.css";

const fileNameFromTitle = (title) => title
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/(^-|-$)/g, "");

export default function DownloadChartButton({ title, targetSelector }) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async (event) => {
    const chart = event.currentTarget.closest(targetSelector);
    if (!chart || downloading) return;

    setDownloading(true);
    try {
      const canvas = await html2canvas(chart, {
        backgroundColor: "#ffffff",
        scale: 2,
        useCORS: true,
        logging: false,
        ignoreElements: (element) => element.hasAttribute("data-download-control"),
      });
      const link = document.createElement("a");
      link.download = `${fileNameFromTitle(title) || "grafica"}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (error) {
      console.error("No se pudo descargar la gráfica:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className={styles.button}
      onClick={handleDownload}
      disabled={downloading}
      data-download-control
      aria-label={`Descargar ${title} en PNG`}
      title="Descargar gráfica en PNG"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3v12" />
        <path d="m7 10 5 5 5-5" />
        <path d="M5 21h14" />
      </svg>
      <span>{downloading ? "Generando…" : "PNG"}</span>
    </button>
  );
}
